import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {DisinfectionComponent} from '@components/disinfection/disinfection.component';

@Component({
    selector: 'app-disinfection-panel',
    standalone: true,
    imports: [CommonModule, RouterModule, DisinfectionComponent],
    templateUrl: './disinfection-panel.component.html',
    styleUrl: './disinfection-panel.component.scss'
})
export class DisinfectionPanelComponent implements OnInit {
    ngOnInit(): void {}
}
